const MINUTE = 1000 * 60;

/**
 * Reads a refetch interval in minutes from an env variable, falling back to a default when it is missing or invalid.
 */
function intervalFromEnv(value: string | undefined, defaultMinutes: number): number {
  const minutes = Number(value);
  if (value === undefined || value.trim() === "" || !Number.isFinite(minutes) || minutes <= 0) return defaultMinutes * MINUTE;
  return minutes * MINUTE;
}

export const RefetchIntervals = {
  posts: intervalFromEnv(import.meta.env.VITE_REFETCH_POSTS_MINUTES, 15),
  // Slides, omroep settings and categories rarely change, so they are refetched less often to reduce load on the site
  slides: intervalFromEnv(import.meta.env.VITE_REFETCH_SLIDES_MINUTES, 60 * 5),
  omroep: intervalFromEnv(import.meta.env.VITE_REFETCH_OMROEP_MINUTES, 60 * 2),
  categories: intervalFromEnv(import.meta.env.VITE_REFETCH_CATEGORIES_MINUTES, 60)
};
